import React, { useState, useEffect } from "react";
import apiService from "../../service";
import { useParams } from "react-router-dom";
import "./criminalCertificatePreview.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import PreviewComponent from "../Preview/Preview";

const CriminalCerificatePreview = () => {
  const { id } = useParams();
  const [dataAvailable, setDataAvailable] = useState(null);

  //Criminal Certificate Preview  get api calling here
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await apiService.getCriminalCertificateDataById(id);
        setDataAvailable(data);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  const breadCrumbArray = [
    {
      name: "Criminal Certificate",
      color: "#000000",
      underline: "none",
      href: "/my-ai/criminal-document",
    },
    {
      name: dataAvailable?.file_name,
      color: "#767676",
      underline: "none",
    },
  ];

  return (
    <>
      <PreviewComponent
        dataAvailable={dataAvailable}
        setDataAvailable={setDataAvailable}
        breadCrumbNames={breadCrumbArray}
        id={id}
      />
    </>
  );
};

export default CriminalCerificatePreview;
